import { useAppSelector } from "@/redux/hooks";
import { Box, SxProps } from "@mui/material";
import { useCheckoutUI } from "../../CheckoutUIProvider";

export const BuyBoxRetailerTerms = ({ sx }: { sx?: SxProps }) => {
  const [state] = useCheckoutUI();
  const { checkoutIntent, itemsToCheckout } = state.context;
  const checkoutItemRetailerId = itemsToCheckout[0]?.retailerId;
  const currentRetailerId =
    checkoutIntent?.retailerId || checkoutItemRetailerId;

  const currentRetailer = useAppSelector((state) => state.retailers).find(
    (item) => item.retailerId === currentRetailerId
  );
  const termsAndService = currentRetailer?.tosUrl;

  return (
    <Box
      component="p"
      sx={{
        fontSize: 12,
        fontWeight: 500,
        marginTop: "4px",
        color: "primary.main",
        textAlign: "center",
        opacity: 0.3,
        ...sx,
      }}
    >
      By ordering, you agree to the {currentRetailer?.displayName}{" "}
      <a
        href={termsAndService?.terms}
        target="_blank"
        rel="noreferrer"
        className="tosLinks"
        style={{ color: "inherit" }}
      >
        Terms
      </a>{" "}
      and{" "}
      <a
        href={termsAndService?.policies}
        target="_blank"
        rel="noreferrer"
        className="tosLinks"
        style={{ color: "inherit" }}
      >
        Privacy Policy
      </a>
      .
    </Box>
  );
};
